import { useState } from "react";
import Post from "../../../helpers/ajax/post";
import ModelWrapper from "./ModelWrapper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var inputClass = "w-full block mb-3 rounded-md border focus:outline-none focus:ring-2 ring-offset-2 ring-black/30 px-3 py-2";
var formButtonClass = "bg-black mt-5 block text-white w-full p-3 font-bold rounded-md focus:outline-none focus:ring-2 ring-offset-2 ring-black/30";

const NewUser = (props) => {
    const { close, successCallback, colony_id } = props;

    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [Email, setEmail] = useState("");
    const [Unit, setUnit] = useState("");
    const [Admin, setAdmin] = useState(false);

    const [hasError, setHasError] = useState(null);
    // When the email already exists, ask the admin to confirm (Phase 4-5 flow).
    const [duplicateInfo, setDuplicateInfo] = useState(null);

    const addUser = async (ev, confirmExisting = false) => {
        ev.preventDefault();
        setHasError(null);
        try {
            await Post("/api/users/add", {
                firstName: FirstName,
                lastName: LastName,
                email: Email,
                unit: Unit,
                admin: Admin,
                colony_id: colony_id,
                confirmExisting,
            });
            toast(confirmExisting ? `Unit ${Unit} added to existing account` : `${FirstName} ${LastName} has been invited`);
            successCallback();
            close();
        } catch (error) {
            if (error?.error === "duplicate") {
                // Show the existing user's name so the admin can decide
                setDuplicateInfo(error?.existingUser || {});
                setHasError(null);
            } else {
                setHasError(error?.error || "an error occurred");
            }
        }
    };

    return (
        <ModelWrapper width={"w-96"} close={close} title={"Add User"}>
            {duplicateInfo ? (
                <div className="pt-4">
                    <p className="text-red-800 mb-3">
                        An account for this email already exists ({duplicateInfo.first_name} {duplicateInfo.last_name}).
                        Adding this unit will use the existing user's name. Add this unit?
                    </p>
                    <button type="button" onClick={(e) => addUser(e, true)} className={formButtonClass}>Add Unit to Existing User</button>
                    <button type="button" onClick={() => setDuplicateInfo(null)} className="mt-3 block w-full text-center text-gray-600 underline">Cancel</button>
                </div>
            ) : (
                <form onSubmit={addUser} className="pt-4">
                    <input value={FirstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" type="text" className={inputClass} />
                    <input value={LastName} onChange={(e) => setLastName(e.target.value)} required placeholder="Last name" type="text" className={inputClass} />
                    <input value={Email} onChange={(e) => setEmail(e.target.value)} required placeholder="Email" type="email" className={inputClass} />
                    <input value={Unit} onChange={(e) => setUnit(e.target.value)} required placeholder="Unit #" type="text" className={inputClass} />
                    <label htmlFor="role_admin" className="flex p-2 align-middle content-center self-center">
                        <input className="inline-block mr-3 w-5 h-5" id="role_admin" type="checkbox" checked={Admin} onChange={(e) => setAdmin(e.target.checked)} />
                        <p>Admin role</p>
                    </label>
                    <button className={formButtonClass}>Add User</button>
                    {!!hasError && <p className="text-red-800 text-left mt-4">{hasError}</p>}
                </form>
            )}
        </ModelWrapper>
    );
};

export default NewUser;